import { put2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { Screen } from "@/shared/v2/queries/interfacesV2";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useScreenPutMutation = () => {
  const { t } = useTranslation();
  const branch = useBranchId();

  const mutation = useMutation({
    onSuccess: () => {
      toast.success(t("success.update"));
    },
    mutationFn: ({ item_id, ...body }: Screen) =>
      put2(
        `/internal/secure/pos/v1/kitchens/edit/screen/${branch}/${item_id}`,
        body
      ),
  });
  return mutation;
};

export default useScreenPutMutation;
